import { GetterTree } from "vuex";
import { IReceptionState } from "./reception-state.store";
import { IRootState } from "../root-state.store";
import { IPagination } from "../../models/generic";
import { IReceptionParameter, IReceptionDetailViewModel } from "../../models/reception";
import { ActivityStatus } from "../../common/enums";

export const getters: GetterTree<IReceptionState, IRootState> = {
  activityStatus: (state: IReceptionState): ActivityStatus => state.activityStatus,
  receptionsSource: (state: IReceptionState) => state.receptionsSource,
  receptionSource: (state: IReceptionState): {
    activityStatus: ActivityStatus,
    detail: IReceptionDetailViewModel
  } => state.receptionSource,
  receptionParameter: (state: IReceptionState): IReceptionParameter => state.receptionParameter,
  pagination: (state: IReceptionState): IPagination => state.pagination,
  receptionSections: (state: IReceptionState) => state.receptionSections,
  loaders: (state: IReceptionState) => state.loaders
}


// WEBPACK FOOTER //
// ./src/store/reception/reception-getters.store.ts